// extracted by mini-css-extract-plugin
export var container = "_fb-1";
export var cornerButtonContainer = "_fb-6";
export var disabled = "_fb-2";
export var dragActive = "_fb-3";
export var fileContainer = "_fb-5";
export var hiddenInput = "_fb-4";
export var widthContainer = "_fb-0";